import PropTypes from "prop-types";
import React from "react";

export const ActiveChapterContext = React.createContext({
  activeChapterId: null,
});

export const ActiveChapterContextProvider = React.memo(
  ({ activeChapterId, children }) => (
    <ActiveChapterContext.Provider value={{ activeChapterId }}>
      {React.Children.only(children)}
    </ActiveChapterContext.Provider>
  ),
);

ActiveChapterContextProvider.propTypes = {
  activeChapterId: PropTypes.number.isRequired,
  children: PropTypes.node,
};

export function useActiveChapter() {
  return React.useContext(ActiveChapterContext);
}

export const WithActiveChapterId = ({ children }) => {
  const activeChapterId = useActiveChapter();

  return children({ activeChapterId });
};
